import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PagingSidePanelType, Box as Section, SidePanel } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { TransactionContent } from 'types/transaction'
import { highlightRowBasedOnId } from 'utils/table/table'
import { useTransactionDetailsTransformer } from '../hooks/useTransactionDetailsTransformer'
import { SidePanelBody } from './SidePanelBody'
import { SidePanelHeaderTransactionHistory } from './SidePanelHeaderTransactionHistory'

interface SidePanelSummaryProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  transactionDetails: TransactionContent
}

export const SidePanelSummary = ({
  isOpen,
  paging,
  onClose,
  transactionDetails,
}: SidePanelSummaryProps) => {
  const { t } = useTranslation()
  const bannerSpacing = useComponentHeight(appBannersId)

  const {
    amountWithCurrency,
    iconUrls,
    transactionType,
    transactionSubType,
    customerReference,
    transactionHash,
    transactionDate,
    transformedData,
    name,
  } = useTransactionDetailsTransformer(transactionDetails, t)

  const smallTabsId = `${customerReference}-${transactionHash}-${transactionDate}`
  const [activeId, setActiveId] = useState(smallTabsId)

  useEffect(() => {
    setActiveId(smallTabsId)
  }, [activeId])

  const transactionRowId = `${transactionDetails?.transactionUUID}-${transactionDetails?.hash}-${transactionDetails?.dateCreated}`

  return (
    <SidePanel
      id="side-panel-transaction-details"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={transactionRowId}
      onActiveRowChange={highlightRowBasedOnId}
      topOffset={bannerSpacing}
      header={
        <SidePanelHeaderTransactionHistory
          data={{
            iconUrls,
            amountWithCurrency,
            transactionType,
            transactionSubType,
            customerReference,
            transformedData,
            name,
          }}
        />
      }
      body={
        <Section tag="section" width="full" background="layer-1">
          <SidePanelBody transactionDetails={transactionDetails} />
        </Section>
      }
    ></SidePanel>
  )
}
